import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    width: 300px;
}
`;

export const ButtonsArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}
`;
